import type { Role } from '@bia-auction/shared-schema';
import { getAccessToken } from './token-store';

/**
 * Decode the **untrusted, display-only** JWT payload for `sub` + `roles`.
 *
 * Lives here rather than in `auth.tsx` so the router's `beforeLoad` guards can read the caller's
 * roles without importing a component module (which would pull React context into route
 * definitions). `auth.tsx` imports it back, so there is still one decoder.
 *
 * **The server is authoritative.** Every action and every read is re-checked there; this only
 * decides which controls and pages are worth rendering.
 */
export function decodeIdentity(): { userId: string | null; roles: Role[] } {
  const token = getAccessToken();
  if (!token) return { userId: null, roles: [] };
  try {
    const payload = token.split('.')[1] ?? '';
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      sub?: string;
      roles?: Role[];
    };
    return { userId: json.sub ?? null, roles: json.roles ?? [] };
  } catch {
    return { userId: null, roles: [] };
  }
}
